import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/ar";
import "dayjs/locale/en-gb";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Required wrapper for all @mui/x-date-pickers components.
 * @see https://mui.com/x/react-date-pickers/base-concepts/
 */
const DatePickersProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const adapterLocale = i18n.language === "ar" ? "ar" : "en-gb";

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
      {children}
    </LocalizationProvider>
  );
};

export default DatePickersProvider;
